import { createAction, props } from '@ngrx/store';

const GET_ROLES = '[Roles] Get Roles';
const GET_ROLES_SORTING = '[Roles] Get Roles With Sorting';
const SAVE_ROLES = '[Roles] Save Roles';
const SENT_ROLES = '[Roles] Sent Roles';
const SET_ROLES = '[Roles] Set Roles';
const UPDATE_ROLES = '[Roles] Update Roles';
const SET_ROLES_TO_DELETE = '[Roles] Set Roles To Delete';
const SENT_DELETE_ROLES = '[Roles] Delete Sent Roles';
const GET_SID_BASED_ROLES = '[Roles] Get SID Based Roles';
const SET_SID_BASED_ROLES = '[Roles] Set SID Based Roles';
const GET_ROLES_BASED_SEARCH = '[Roles] Get Roles Based Search';
const GET_ALL_ROLES_BY_APP_ID = '[Roles] Get All Roles By App Id';
const SET_ALL_ROLES_SORTED_BY_NAME = '[Roles] Set All Roles Sorted By Name';
const ERROR_MESSAGE = '[Roles] Error Message Roles';

const getRoles = createAction(GET_ROLES, props<{ apiConstants: any; filter?: any }>());

const getRolesWithSorting = createAction(GET_ROLES_SORTING, props<{ apiConstants: any; filter?: any }>());

const setRoles = createAction(SET_ROLES, props<{ rolesTable: any; totalRecords?: any }>());

const sentRoles = createAction(SENT_ROLES, props<{ apiConstants: any; saveRolesData: any }>());
const saveRoles = createAction(SAVE_ROLES, props<{ saveRolesData: any }>());

const updateRoles = createAction(UPDATE_ROLES, props<{ updateRolesData: any }>());

const setRolesToDelete = createAction(SET_ROLES_TO_DELETE, props<{ rolesWithRefAndDeleted: any; filterRoles: any }>());

const sentDeleteRoles = createAction(
  SENT_DELETE_ROLES,
  props<{ apiConstants: any; rolesId: string; roleName: string }>()
);

const getSidBasedRoles = createAction(
  GET_SID_BASED_ROLES,
  props<{
    apiConstants: any;
    sid: any;
  }>()
);
const setSidBasedRoles = createAction(
  SET_SID_BASED_ROLES,
  props<{
    sidRoleData: any;
  }>()
);
const getRolesBasedOnSearch = createAction(GET_ROLES_BASED_SEARCH, props<{ apiConstants: any; searchFields: any }>());
const getErrorMessage = createAction(ERROR_MESSAGE, props<{ errorMessage: any }>());

const getAllRolesByAppId = createAction(GET_ALL_ROLES_BY_APP_ID, props<{ apiConstants: any }>());

const setAllRolesSortedByName = createAction(SET_ALL_ROLES_SORTED_BY_NAME, props<{ sortedRolesByName: any[] }>());

export {
  getRoles,
  saveRoles,
  updateRoles,
  setRolesToDelete,
  setRoles,
  sentRoles,
  sentDeleteRoles,
  getSidBasedRoles,
  setSidBasedRoles,
  getRolesBasedOnSearch,
  getAllRolesByAppId,
  setAllRolesSortedByName,
  getErrorMessage,
  getRolesWithSorting
};

// export const getModernizedRoles = createAction(
//   '[Roles] Get Modernized Roles',
//   props<{ apiConstants: string; filter: any }>()
// );
